module.exports = __webpack_public_path__ + "static/media/img-1-1000x600.35a52547.jpg";